export default __webpack_public_path__ + "static/pool_cleaning-f847c4b5cd07e2bb3a3a6a8e40a4a55c.jpg";